<mat-nav-list [class.elz-collapsed]="!$isSidebarExpanded()">
  @for (item of $menuItems(); track item.menuId) {
    @if (item.childMenus?.length) {
      <mat-list-item
        (click)="toggle(item.description)"
        [matTooltip]="!$isSidebarExpanded() ? item.description : undefined"
        data-testid="nav-list-item"
      >
        @if ($isSidebarExpanded()) {
          <mat-icon matListItemIcon data-testid="nav-list-item-icon">{{ item.icon }}</mat-icon>
        }

        @if ($isSidebarExpanded()) {
          <span [attr.data-testid]="item.name + '-nav-list-item-description'">{{ item.description }}</span>
        } @else {
          <ng-container [ngTemplateOutlet]="collapsedItem" [ngTemplateOutletContext]="{ item: item }" />
        }

        @if ($isSidebarExpanded()) {
          <span matListItemMeta class="mat-icon-container">
            <mat-icon data-testid="nav-list-item-expand-icon">
              {{ expanded[item.description] ? keyboardArrowUpIcon : keyboardArrowRightIcon }}
            </mat-icon>
          </span>
        }
      </mat-list-item>
      @if (expanded[item.description]) {
        <div class="elz-sub-list-items" data-testid="nav-list-item-children">
          @for (subItem of item.childMenus; track subItem.menuId) {
            <ng-container
              [ngTemplateOutlet]="noChildren"
              [ngTemplateOutletContext]="{ item: subItem, isChild: true }"
            />
          }
        </div>
      }
    } @else {
      <ng-container
        [ngTemplateOutlet]="noChildren"
        [ngTemplateOutletContext]="{ item: item, isChild: false }"
      />
    }
  }

  <ng-template #noChildren let-item="item" let-isChild="isChild">
    @if (item.navigateUrls?.[0] === 'administration') {
      <button
        mat-list-item
        (click)="navigateToAdmin()"
        [matTooltip]="!$isSidebarExpanded() ? item.description : undefined"
        [attr.data-testid]="item.name + '-nav-list-item'"
      >
        @if ($isSidebarExpanded() && item.icon && !isChild) {
          <mat-icon matListItemIcon [attr.data-testid]="item.icon + '-nav-list-icon'">
            {{ item.icon }}
          </mat-icon>
        }
        @if ($isSidebarExpanded()) {
          <div matListItemTitle [attr.data-testid]="item.name + '-nav-list-item-description'">
            {{ item.description }}
          </div>
        } @else {
          <ng-container [ngTemplateOutlet]="collapsedItem" [ngTemplateOutletContext]="{ item: item }" />
        }
      </button>
    } @else if (item.navigateUrls?.[0] === 'signout') {
      <button
        mat-list-item
        (click)="signOut()"
        [matTooltip]="!$isSidebarExpanded() ? item.description : undefined"
        [attr.data-testid]="item.name + '-nav-list-item'"
      >
        @if ($isSidebarExpanded() && item.icon && !isChild) {
          <mat-icon matListItemIcon [attr.data-testid]="item.icon + '-nav-list-icon'">
            {{ item.icon }}
          </mat-icon>
        }
        @if ($isSidebarExpanded()) {
          <div matListItemTitle [attr.data-testid]="item.name + '-nav-list-item-description'">
            {{ item.description }}
          </div>
        } @else {
          <ng-container [ngTemplateOutlet]="collapsedItem" [ngTemplateOutletContext]="{ item: item }" />
        }
      </button>
    } @else {
      <a
        mat-list-item
        routerLinkActive
        [routerLink]="item.navigateUrls?.length ? ['/'].concat(item.navigateUrls) : undefined"
        [routerLinkActiveOptions]="{
          exact:
            item.navigateUrls?.[item.navigateUrls.length - 1] === 'surf' ||
            item.navigateUrls?.[item.navigateUrls.length - 1] === 'pipelines'
        }"
        [matTooltip]="!$isSidebarExpanded() ? item.description : undefined"
        #rla="routerLinkActive"
        [activated]="rla.isActive"
        [attr.data-testid]="item.name + '-nav-list-item'"
      >
        @if ($isSidebarExpanded() && item.icon && !isChild) {
          <mat-icon matListItemIcon [attr.data-testid]="item.icon + '-nav-list-icon'">
            {{ item.icon }}
          </mat-icon>
        }
        @if ($isSidebarExpanded()) {
          <div matListItemTitle [attr.data-testid]="item.name + '-nav-list-item-description'">
            {{ item.description }}
          </div>
        } @else {
          <ng-container [ngTemplateOutlet]="collapsedItem" [ngTemplateOutletContext]="{ item: item }" />
        }
      </a>
    }
  </ng-template>
</mat-nav-list>

<ng-template #collapsedItem let-item="item">
  <mat-icon>{{ item.icon }}</mat-icon>
</ng-template>
